import React from 'react'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'

const RowHead: React.FC = ({ children }) => {
  return (
    <div className={classNames([styles.Row, styles.RowHead])}>{children}</div>
  )
}

export default RowHead
